import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase web config is sourced from environment variables (see frontend/.env).
// NOTE: Firebase web API keys are public identifiers (they ship to every browser),
// so this is hygiene, not secrecy. Real security comes from Firebase Auth rules
// + Authorized Domains in the Firebase console.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Wrap init in try/catch so a misconfigured env or missing config never
// crashes the whole app at module-load (which would cascade into the
// top-level ErrorBoundary "ZenScroll had trouble loading" fallback when any
// page that imports `auth` mounts — e.g. Settings). Pages that rely on web
// Firebase will degrade gracefully when `auth` is null.
let app = null;
let auth = null;
try {
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
} catch (err) {
  console.error('[firebase] init failed:', err);
}

export { auth };
export default app;
